import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgImageSliderComponent } from './ng-image-slider.component';

@NgModule({
  declarations: [NgImageSliderComponent],
  imports: [CommonModule],
  exports: [NgImageSliderComponent],
})
export class NgImageSliderCompatModule { }
